export const ENTITY_TYPE = {
    CORPORATION: 'corporation',
    SOLE_PROPRIETOR: 'soleProprietor',
    NATURAL_PERSON: 'naturalPerson',
}

export const CURRENCIES = {
    CZK: 'CZK',
    EUR: 'EUR',
    USD: 'USD',
    SKK: 'SKK',
}
